/* eslint-disable @typescript-eslint/naming-convention */
import {Entity} from 'app/core/main.entity';
import 'reflect-metadata';
import {Type} from 'class-transformer';
import {FormElementText} from 'app/entities/form/formElementText.entity';
import {FormElementTextarea} from 'app/entities/form/formElementTextarea.entity';
import {FormElementSelect} from 'app/entities/form/formElementSelect.entity';
import {FormElementCheckbox} from 'app/entities/form/formElementCheckbox.entity';
import {FormElementData, FormElementDataRange} from 'app/entities/form/formElementDate.entity';
import {FormElementFile} from 'app/entities/form/formElementFile.entity';
import {FormElementGroup} from 'app/entities/form/formElementGroup.entity';
import {FormElementNumber} from 'app/entities/form/formElementNumber.entity';
import {FormElementRadio} from 'app/entities/form/formElementRadio.entity';
import {FormElementRepeater} from 'app/entities/form/formElementRepeater.entity';
import {FormElementSegment} from 'app/entities/form/formElementSegment.entity';
import {FormElementToggle} from 'app/entities/form/formElementToggle.entity';
import {FormElementCustomCalendarRepeat} from 'app/entities/form/formElementCustomCalendarRepeat.entity';

export class Form extends Entity {
  id?: number; // non exist form
  fieldId?: number; // exist form
  values?: any = null;

  title?: string;
  showModalTitle? = true;
  required? = false;

  @Type(() => Entity, {
    discriminator: {
      property: 'type',
      subTypes: [
        {value: FormElementText, name: 'text'},
        {value: FormElementTextarea, name: 'textarea'},
        {value: FormElementSelect, name: 'select'},
        {value: FormElementCheckbox, name: 'checkbox'},
        {value: FormElementData, name: 'date'},
        {value: FormElementDataRange, name: 'dateRange'},
        {value: FormElementFile, name: 'file'},
        {value: FormElementGroup, name: 'group'},
        {value: FormElementNumber, name: 'number'},
        {value: FormElementRepeater, name: 'repeater'},
        {value: FormElementSegment, name: 'segments'},
        {value: FormElementToggle, name: 'toggle'},
        {value: FormElementRadio, name: 'radio'},
        {value: FormElementCustomCalendarRepeat, name: 'calendarRepeat'}
      ],
    },
    keepDiscriminatorProperty: true
  })
  fields: FormElements[] = [];

  getId?() {
    return this.isExist() ? this.fieldId : this.id;
  }

  isExist?() {
    return typeof this.fieldId !== 'undefined' && !!this.fieldId;
  }
}

export type FormElements =
  FormElementText
  | FormElementTextarea
  | FormElementSelect
  | FormElementCheckbox
  | FormElementData
  | FormElementDataRange
  | FormElementFile
  | FormElementGroup
  | FormElementNumber
  | FormElementRadio
  | FormElementRepeater
  | FormElementSegment
  | FormElementToggle;
